<div class="breadcrumbs my-5">
	<div class="mr-2">You are here: </div>
	<nz-breadcrumb nzSeparator=">">
		<nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs">
			<a [attr.href]="breadcrumb.url" (click)="navigate(breadcrumb.url, $event)">{{ breadcrumb.label }}</a>
		</nz-breadcrumb-item>
	</nz-breadcrumb>
</div>
